<template>
  <v-dialog
      max-width="600px" 
        :model-value="displayDialog" :persistent="true" :class="isMobile ? 'mobile' : 'desktop'">
    <v-card
      class="d-flex flex-column align-content-space-around download-app-dialog"
    >
      <v-card-title class="d-flex justify-content-center">
        <h1 class="text-wrap text-center" v-html="title"></h1>
        <v-btn
          :ripple="false"
          icon="mdi-close"
          variant="plain"
          @click="close"
          class="close-dialog"
        ></v-btn>
      </v-card-title>
      <v-card-subtitle
        v-if="subtitle"
        class="d-flex justify-center justify-content-center"
      >
        <p class="align-self-center">
          {{ subtitle }}
        </p>
      </v-card-subtitle>
      <v-card-text class="d-flex align-self-center justify-center">
        <div
          class="two-posters mx-auto"
          v-bind:class="{ download: dialogType === 'live' }"
        ></div>
      </v-card-text>
      <v-card-actions class="d-flex justify-content-center">
        <v-btn
          class="no-hover"
          :color="'#bd2130'"
          :ripple="false"
          :href="
            isIphone
              ? 'https://itunes.apple.com/us/app/flixlatino-go/id1113757930?mt=8'
              : 'https://play.google.com/store/apps/details?id=com.trespixels.flixlatino'
          "
          variant="flat"
        >
          {{ okbtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  displayDialog: Boolean,
  isMobile: Boolean,
  isAndroid: Boolean,
  isIphone: Boolean,
  dialogType: String,
});

const emit = defineEmits(["update:modelValue"]);

const title = computed(() => {
  if (props.dialogType === "live") {
    return t("plans.downloadAppDialog.title");
  } else {
    return t("plans.downloadAppPopup.title");
  }
});

const subtitle = computed(() => {
  var subtitle = null;
  if (props.dialogType === "live") {
    subtitle = t("plans.downloadAppDialog.subtitle");
  } else {
    subtitle = t("plans.downloadAppPopup.subtitle");
  }
  return subtitle ?? null;
});

const okbtn = computed(() => {
  if (props.dialogType === "live") {
    return t("plans.downloadAppDialog.okBtn");
  } else {
    return t("plans.downloadAppPopup.okBtn");
  }
});

function close() {
  emit("update:modelValue", false);
  emit("playLiveChannel", true);
}
</script>

<style lang="scss" scoped>
.download-app-dialog {
  padding-bottom: 2em;
}

.no-hover:hover :deep(.v-btn__overlay) {
  background-color: transparent;
  text-decoration: none !important;
  opacity: 1;
}
:deep(.v-card) {
  box-shadow: none;
  border: transparent none;
  box-sizing: unset;
}
.v-dialog > .v-overlay__content > .v-card {
  background: url("@/assets/img/plans/plan-upgrade-popup-bg.svg") no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 32px;
  .close-dialog {
    position: fixed;
    top: 6px;
    right: 26px;
    @media (max-width: 480px) {
      position: fixed;
      top: 0;
      right: 6px;
    }
  }
  .two-posters {
    background: url("/img/two-posters-6.png") no-repeat;
    background-size: contain;
    background-position: center;
    width: 100%;
    padding-top: 70%;
    &.download {
      background: url("/img/two-posters-6.png") no-repeat;
      background-size: contain;
    }
  }

  .v-card-title {
    padding: 0;
    height: 100px;
    margin-top: 36px;
    font-size: 1em;
    h1 {
      font-size: 2.5em;
      line-height: 40px;
      width: 90%;
      height: 100px;
      white-space: break-spaces !important;
      @media (max-width: 480px) {
        margin-top: 0.5em;
        font-size: 2em;
        line-height: 1.1em;
      }
    }
  }
  .v-card-text {
    width: 472px;
    max-height: 300px;
    @media (max-width: 480px) {
      width: 280px;
      max-height: 300px;
    }
  }
  .v-card-subtitle {
    margin-top: 16px;
    font-size: 1.2em;
    p {
      width: 80%;
      white-space: break-spaces;
      text-align: center;
    }
  }
  .v-card-actions > .v-btn {
    font-size: 1em;
    text-transform: none;
    min-width: 260px;
    @media (max-width: 480px) {
      font-size: 0.9em;
      line-height: 0.9em;
    }
  }
}
</style>
